var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxPayerDeclaration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_43bdfd6e3648c44a5a7f05b1189499a73a2177b79eff100c7bce00b7310d4413",
    x1: 86.084,
    y1: 36.659,
    x2: 126.694,
    y2: 36.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_43bdfd6e3648c44a5a7f05b1189499a73a2177b79eff100c7bce00b7310d4413",
    "data-name": "C_BG_shellbar",
    x1: 2691.489,
    y1: 1535.206,
    x2: 2730.921,
    y2: 1535.206,
    gradientTransform: "rotate(-11.479 -5681.476 13889.285)",
    xlinkHref: "#SVGID_0_43bdfd6e3648c44a5a7f05b1189499a73a2177b79eff100c7bce00b7310d4413"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M139.191 103.445v30.51h-83.44V44.464M78.555 21.66h60.636v46.629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M78.558 21.661L55.755 44.464h22.803V21.661zM149.536 74.37l16.879 12.959M143.134 70.354c-.974-1.329-2.828-2.073-4.622-2.064l-13.306 7.083c-2.733 1.676-3.37 2.233-4.91 5.104l-6.519 12.501c.011 2.33.72 4.169 2.702 4.535M141.772 93.404l.002-3.23-4.541-3.442"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M123.03 100.572l-5.954 6.013-7.797 3.242 2.96-8.033 37.295-37.65 5.237 4.388-24.483 24.716"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M141.739 93.471l-13.858.066a4.955 4.955 0 00.047 9.909l19.917-.095"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M147.732 103.34s3.244.409 6.435-3.405l3.464 2.123M156.728 104.595l12.19-18.756 7.409 4.816-12.19 18.756z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_43bdfd6e3648c44a5a7f05b1189499a73a2177b79eff100c7bce00b7310d4413)",
    d: "M87.334 31.034h38.109v11.25H87.334z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M69.499 60.461h55.945M69.499 67.425h27.85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M68.797 123.503s4.303-5.154 6.984-11.855c2.855-7.137-9.168-6.533-9.772.165-.41 4.551 8.494 4.556 12.596 7.924.648.532 1.587.173 1.78-.642.653-2.77 1.258-3.491 2.808-2.012 1.009.963 2.306.499 3.284-3.263 1.138-4.377 3.673 3.049 4.621 3.757 1.305.973 1.067-3.365 4.776-4.721 2.61-.954 4.952 1.423 7.741-.769",
    stroke: "url(#SVGID_1_43bdfd6e3648c44a5a7f05b1189499a73a2177b79eff100c7bce00b7310d4413)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxPayerDeclaration);
export default __webpack_public_path__ + "static/media/taxPayerDeclaration.402c4b18e7a2496a5108ad4bfca413a2.svg";
export { ForwardRef as ReactComponent };